module.exports = __webpack_public_path__ + "img/emoji_13.6423bee8.png";